/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.tool.access.rpc.ToolAccessService
 */
import * as References from './ToolAccessService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.tool.access.rpc.ToolAccessService#requestToolAccess
 */
export const REQUEST_TOOL_ACCESS_MUTATION_FIELD_NAME =
  'com_hubspot_tool_access_rpc_ToolAccessService_requestToolAccess';
export const REQUEST_TOOL_ACCESS_MUTATION: RegisteredQuery<
  'result',
  References.RequestToolAccessRequestType,
  References.RequestToolAccessResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REQUEST_TOOL_ACCESS_MUTATION_FIELD_NAME,
  args: ['scope', 'approverUserId', 'message'],
  fetcher(
    request: References.RequestToolAccessRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RequestToolAccessResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.requestToolAccessRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.tool.access.rpc.ToolAccessService#getActiveToolAccessRequestForScope
 */
export const GET_ACTIVE_TOOL_ACCESS_REQUEST_FOR_SCOPE_QUERY_FIELD_NAME =
  'com_hubspot_tool_access_rpc_ToolAccessService_getActiveToolAccessRequestForScope';
export const GET_ACTIVE_TOOL_ACCESS_REQUEST_FOR_SCOPE_QUERY: RegisteredQuery<
  'result',
  References.GetActiveToolAccessRequestForScopeRequestType,
  References.GetActiveToolAccessRequestForScopeResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_ACTIVE_TOOL_ACCESS_REQUEST_FOR_SCOPE_QUERY_FIELD_NAME,
  args: ['scopeName', 'locale'],
  fetcher(
    request: References.GetActiveToolAccessRequestForScopeRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetActiveToolAccessRequestForScopeResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getActiveToolAccessRequestForScopeRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
